module.exports = __webpack_public_path__ + "img/whiteDownArrow.5606ac23.svg";